<template>
    <div class="login-container">
        <!-- 左侧背景区域 -->
        <div class="background-section">
            <div class="background-overlay"></div>
            <!-- 使用图片替代视频 -->
            <div class="background-image"></div>
            <div class="background-content">
                <h2>企业管理系统</h2>
                <p>高效、安全、可靠的企业管理解决方案</p>
            </div>
        </div>

        <!-- 右侧登录表单 -->
        <div class="login-box">
            <div class="login-content">
                <div class="login-header">
                    <div class="logo">
                        <i class="el-icon-s-platform"></i>
                        <span>企业管理系统</span>
                    </div>
                    <div class="login-title">欢迎登录</div>
                    <p class="login-subtitle">请使用您的账号密码登录系统</p>
                </div>

                <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login-form">
                    <el-form-item prop="csn">
                        <el-input
                                v-model="loginForm.csn"
                                placeholder="请输入公司编码"
                                prefix-icon="el-icon-office-building"
                                size="large"
                        />
                    </el-form-item>
                    <el-form-item prop="username">
                        <el-input
                                v-model="loginForm.username"
                                placeholder="请输入账号"
                                prefix-icon="el-icon-user"
                                size="large"
                        />
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                                type="password"
                                v-model="loginForm.password"
                                placeholder="请输入密码"
                                prefix-icon="el-icon-lock"
                                size="large"
                                show-password
                        />
                    </el-form-item>
                    <el-form-item class="login-actions">
                        <el-button
                                type="primary"
                                @click="login()"
                                class="login-btn"
                                size="large"
                        >
                            登录
                        </el-button>
                        <el-button
                                @click="resetLoginForm"
                                class="reset-btn"
                                size="large"
                        >
                            重置
                        </el-button>
                    </el-form-item>
                </el-form>

                <div class="login-footer">
                    <p>© 2023 企业管理系统 · 版权所有</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { hexMD5 } from '../utils/md5' //引入
    export default {
        name: "LoginView",
        data() {
            return {
                loginForm: {
                    csn:null,
                    username: null,
                    password: null,
                },
                objArr:{},
                loginFormRules: {
                    username: [
                        { required: true, message: "请输入账号", trigger: "blur" },
                    ],
                    password: [
                        { required: true, message: "请输入密码", trigger: "blur" },
                    ],
                },
            };
        },
        created(){
        },
        mounted() {
            document.body.style.margin = '0';
        },
        methods: {
            //重置按钮
            resetLoginForm() {
                this.$refs.loginFormRef.resetFields();
            },
            //登录按钮
            login() {
                this.$refs.loginFormRef.validate((valid) => {
                    if (valid) {
                        console.log(this.loginForm,99);
                        let obj = {
                            username: this.loginForm.username,
                            password: hexMD5(this.loginForm.password),
                            csn: this.loginForm.csn,
                            appid:'20220101',
                            is_admin:1
                        }
                        this.objArr = obj;
                        obj.sign=this.sign(this.objArr);
                        this.$axios.getProxyUserLogin(this.objArr).then(res=>{
                            if (res.code == 200) {
                                console.log('login rs-----',res)
                                this.$message.success('登录成功');
                                sessionStorage.setItem("csn", this.loginForm.csn);
                                sessionStorage.setItem("token", res.data.token);
                                sessionStorage.setItem("extract_shop_id", res.data.extract_shop_id);
                                sessionStorage.setItem("extract_clerk_id", res.data.extract_clerk_id);
                                sessionStorage.setItem("proxy_id",res.data.proxy_id);
                                sessionStorage.setItem("proxy", JSON.stringify(res.data.proxy));
                                sessionStorage.setItem("remark", res.data.remark);
                                sessionStorage.setItem('company_id', res.data.company_id);
                                sessionStorage.setItem('employee_id', res.data.employee_id);
                                sessionStorage.setItem('creator_id', res.data.employee_id);

                                sessionStorage.setItem('creator_name', res.data.employee? res.data.employee.name_cn:'');

                                sessionStorage.setItem('user_id', res.data.id);
                                sessionStorage.setItem('uid', res.data.id);
                                // window.localStorage.setItem("menu", res.data.menu);
                                window.sessionStorage.setItem("userName", res.data.user_name);
                                sessionStorage.setItem("company_role_id", res.data.company_role_id);
                                sessionStorage.setItem("roles", JSON.stringify(res.data.roles));
                                this.$router.replace("/home");
                            } else {
                                this.$message.error(res.msg);
                            }
                        }).catch(error=>{
                            console.log(error);
                        })
                    }
                });
            },
            sign(unordered){
                const secret="37506178be498bf490e2e25b8f5ccb4d";
                const ordered = {};
                Object.keys(unordered).sort().forEach(function(key) {
                    if(!Array.isArray(unordered[key])){
                        ordered[key] = unordered[key];
                    }
                });
                var rs="";
                for(var m in ordered ){
                    rs +=m+"="+ordered[m]+"&";
                }

                return hexMD5(hexMD5(rs+"key="+secret)).toLocaleUpperCase();

            },

        },
    };
</script>

<style lang="less" scoped>
    .login-container {
        height: 100vh;
        display: flex;
        margin: 0;
        padding: 0;
        background-color: #f5f7fa;
        overflow: hidden;

        .background-section {
            flex: 1;
            position: relative;
            overflow: hidden;

            .background-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(135deg, rgba(64, 158, 255, 0.8) 0%, rgba(103, 194, 58, 0.7) 100%);
                z-index: 1;
            }

            .background-image {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url('../assets/upload/login_bg.jpg') no-repeat center center;
                background-size: cover;
                filter: brightness(0.9);
            }

            .background-content {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                text-align: center;
                color: white;
                z-index: 2;
                width: 80%;

                h2 {
                    font-size: 36px;
                    font-weight: 600;
                    margin-bottom: 20px;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                }

                p {
                    font-size: 18px;
                    opacity: 0.9;
                    max-width: 500px;
                    margin: 0 auto;
                    line-height: 1.6;
                }
            }
        }

        .login-box {
            width: 450px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-shadow: -5px 0 30px rgba(0, 0, 0, 0.08);
            position: relative;
            z-index: 10;

            .login-content {
                padding: 40px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .login-header {
                    text-align: center;
                    margin-bottom: 40px;

                    .logo {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 25px;

                        i {
                            font-size: 32px;
                            color: #409EFF;
                            margin-right: 10px;
                        }

                        span {
                            font-size: 20px;
                            font-weight: 600;
                            color: #303133;
                        }
                    }

                    .login-title {
                        font-size: 28px;
                        font-weight: 600;
                        color: #303133;
                        margin-bottom: 10px;
                    }

                    .login-subtitle {
                        color: #909399;
                        font-size: 14px;
                    }
                }

                .login-form {
                    .el-form-item {
                        margin-bottom: 24px;

                        /deep/ .el-input__inner {
                            height: 48px;
                            border-radius: 8px;
                            border: 1px solid #e4e7ed;
                            transition: all 0.3s;
                            font-size: 15px;

                            &:focus {
                                border-color: #409EFF;
                                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                            }
                        }

                        /deep/ .el-input__prefix {
                            left: 12px;
                            color: #c0c4cc;
                        }
                    }

                    .login-actions {
                        margin-top: 30px;
                        margin-bottom: 0;

                        .login-btn {
                            width: 100%;
                            height: 48px;
                            border-radius: 8px;
                            background: linear-gradient(135deg, #409EFF, #337ecc);
                            border: none;
                            font-size: 16px;
                            font-weight: 500;
                            transition: all 0.3s;
                            margin-bottom: 15px;

                            &:hover {
                                transform: translateY(-2px);
                                box-shadow: 0 6px 15px rgba(64, 158, 255, 0.4);
                            }
                        }

                        .reset-btn {
                            width: 100%;
                            height: 48px;
                            border-radius: 8px;
                            background: #f5f7fa;
                            border: 1px solid #e4e7ed;
                            color: #606266;
                            font-size: 16px;
                            font-weight: 500;
                            transition: all 0.3s;

                            &:hover {
                                background: #e4e7ed;
                                color: #303133;
                            }
                        }
                    }
                }

                .login-footer {
                    margin-top: 40px;
                    text-align: center;

                    p {
                        color: #c0c4cc;
                        font-size: 13px;
                    }
                }
            }
        }
    }

    /* 响应式设计 */
    @media (max-width: 992px) {
        .login-container {
            flex-direction: column;

            .background-section {
                height: 30vh;
                min-height: 200px;

                .background-content {
                    h2 {
                        font-size: 24px;
                    }

                    p {
                        font-size: 14px;
                    }
                }
            }

            .login-box {
                width: 100%;
                height: 70vh;

                .login-content {
                    padding: 30px 25px;
                }
            }
        }
    }

    @media (max-width: 576px) {
        .login-container {
            .login-box {
                .login-content {
                    padding: 25px 20px;

                    .login-header {
                        .login-title {
                            font-size: 24px;
                        }
                    }
                }
            }
        }
    }

    /* 动画效果 */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .login-content {
        animation: fadeInUp 0.5s ease-out;
    }

    /deep/ body {
        margin: 0;
        padding: 0;
    }
</style>
